// Multilingual landing config. Source of truth for hreflang + sitemap + footer switcher.
// French is the canonical language served at "/"; every other lang gets a single landing page at "/{code}".

export interface LangConfig {
  code: "fr" | "en" | "nl" | "de" | "es" | "it";
  hreflang: string; // ISO with region where useful
  label: string; // shown in switcher
  flag: string; // emoji
  path: string; // "/" for fr, "/{code}" for others
}

export const LANGS: LangConfig[] = [
  { code: "fr", hreflang: "fr-FR", label: "Français", flag: "🇫🇷", path: "/" },
  { code: "en", hreflang: "en", label: "English", flag: "🇬🇧", path: "/en" },
  { code: "nl", hreflang: "nl", label: "Nederlands", flag: "🇳🇱", path: "/nl" },
  { code: "de", hreflang: "de", label: "Deutsch", flag: "🇩🇪", path: "/de" },
  { code: "es", hreflang: "es", label: "Español", flag: "🇪🇸", path: "/es" },
  { code: "it", hreflang: "it", label: "Italiano", flag: "🇮🇹", path: "/it" },
];

export const X_DEFAULT_PATH = "/";
